import React from 'react'

export function BasicCountField(props: { value: string[] | null | undefined }) {
	return <div className='cell-data-number'>{props.value?.length}</div>
}
